import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=018c706e"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports